import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RegisterDialogComponent} from './register-dialog.component';
import {TranslateModule} from '@xref/ngx';
import {DialogCloseModule} from '../dialog-close/dialog-close.module';
import {VerifyCodeFormModule} from '../verify-code-form/verify-code-form.module';
import {MatCheckboxModule} from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ReactiveFormsModule} from "@angular/forms";
import {PendingVerificationModule} from "../pending-verification/pending-verification.module";

@NgModule({
  declarations: [RegisterDialogComponent],
  imports: [
    VerifyCodeFormModule,
    DialogCloseModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    FontAwesomeModule,
    PendingVerificationModule
  ],
  exports: [RegisterDialogComponent]
})
export class RegisterDialogModule {}
